// Shared demo access code (GAPS S23). The demo logins mint real staff JWTs
// against a live AI budget, so the API gates them behind a code we hand to
// prospects. Held in sessionStorage, not localStorage: closing the tab ends the
// demo session, and a shared/kiosk browser doesn't leak the code to the next
// visitor. It is a sales code, not a credential — the API never returns it.
export const DEMO_CODE_KEY = 'fmla_demo_code_v1';

export function getDemoCode() {
  try {
    return sessionStorage.getItem(DEMO_CODE_KEY) || '';
  } catch {
    return ''; // Safari private mode throws on sessionStorage
  }
}

export function setDemoCode(code) {
  try {
    if (code) sessionStorage.setItem(DEMO_CODE_KEY, code);
    else sessionStorage.removeItem(DEMO_CODE_KEY);
  } catch {
    /* non-fatal: the code just won't persist across page loads */
  }
}

export function clearDemoCode() {
  setDemoCode('');
}
